import { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col } from "react-bootstrap";
import SocialMediaRequests from "../../../components/common/SocialMediaRequests/SocialMediaRequests";
import{
    EndorsementsTestimonialsSection,
    EndorsementsTitle,
    TestimonialsListWrap,
} from "./EndorsementsStyle"
import { endorsementsHandler } from "../../../redux/slices/endorsements/endorsements-slice";
import { useDispatch ,useSelector} from "react-redux";
import { MESSAGE } from "../../../utils/message";
import MetaComponent from "../../../components/common/metaComponent";

const Endorsements = () => {
    const dispatch:any = useDispatch();
    const endorsementsList = useSelector((state:any) => state?.endorsements?.data);
    useEffect(() => {
      dispatch(endorsementsHandler())
    },[])
    return (
        <>
        <MetaComponent 
            keywords=""
            description=""
            ogTitle="Endorsements & Testimonials | GreatNonprofits"
            ogDescription=""
            ogUrl="https://www.about.greatnonprofits.org/endorsements"
            ogImage="https://static.wixstatic.com/media/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg/v1/fit/w_2500,h_1330,al_c/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg"
        />
        <EndorsementsTestimonialsSection className="endorsements-banner">
        <Container className="cont-w">
            <Row>
                <Col sm="12">
                    <EndorsementsTitle>{MESSAGE.endorsementsTestimonials}</EndorsementsTitle>
                    
                    <TestimonialsListWrap>
                        {endorsementsList?.data?.map((endorsements:any, index:number) =>(
                             <SocialMediaRequests endorsementsData={endorsements} key={index+1}/>
                        )) }
                    </TestimonialsListWrap>
                </Col>
            </Row>
        </Container>
    </EndorsementsTestimonialsSection>
        </>
    
    )
};
export default Endorsements;